import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { BrowserMediaQueries, CssSelectors } from '../../../styles/styles';

const {
	colors,
	common: { borderRadius },
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		'::-webkit-scrollbar': {
			background: colors.background.main,
			width: 8,
		},
		'::-webkit-scrollbar-thumb': {
			backgroundColor: colors.border.main,
			borderRadius,
			padding: '0 2px',
		},
		marginRight: 4,
		overflow: 'auto',
		position: 'relative',
		...CssSelectors.allChildren(
			{
				marginBottom: 0,
			},
			'.message:last-child'
		),
	},
	dateSeparator: {
		':before': {
			background: colors.border.main,
			content: "' '",
			height: 1,
			position: 'absolute',
			top: 12,
			width: '100%',
		},
		marginBottom: 20,
		position: 'relative',
		...CssSelectors.allChildren(
			{
				background: colors.background.main,
				color: colors.text.main,
				fontSize: 12,
				marginLeft: 20,
				padding: '0 12px',
				position: 'relative',
				zIndex: 0,
			},
			'span'
		),
		[BrowserMediaQueries.IE11]: {
			transform: 'rotate(180deg)',
		},
	},
	noMessages: {
		color: colors.text.main,
		paddingTop: 30,
		[BrowserMediaQueries.IE11]: {
			transform: 'rotate(180deg)',
		},
	},
	otherPhoneNumbers: {
		margin: '10px auto 0',
		maxWidth: 300,
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				color: colors.text.main,
			},
			'span'
		),
	},
});
